import {
  Component,
  ViewEncapsulation,
  OnInit,
  Input,
  Output,
  EventEmitter
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  AnalyticsService,
  CustomerService,
  StorageService
} from '../../../../_services/index';
import {
  DataService,
  OptionsserviceService,
  LoansService,
  OperationsService
} from '../../../../_services/index';
import { IonRangeSliderComponent } from 'ng2-ion-range-slider';
import { HttpClient } from '@angular/common/http';
import {Location} from '@angular/common';

@Component({
  selector: 'app-analyticsloanrepayment',
  templateUrl: './analyticsloanrepayment.component.html',
  styleUrls: ['./analyticsloanrepayment.component.css']
})
export class AnalyticsloanrepaymentComponent implements OnInit {
  currentUser: any;
  view: any = 'data_view';
  @Input('details') details: any;
  phone_ownership: any;
  average_credit: any;
  average_income: any;
  salary_amount: any;
  @Input('token') token: any;
  @Input('parentRouteId') parentRouteId: any;
  @Input('loan') loan: any;
  selected_analytics = '1';
  nodesandscores: any;
  analytics_result: any;
  sub: any;
  text = 'Repayment Analytics';
  average_monthly_cost = 0;
  average_calls_per_month = 0;
  full_analytics: any;
  lender_id: any;
  borrower_id: any;
  principal: any;
  maturity_date: any;
  account_card_id: any;
  loan_request_id: any;
  card_id: any;
  passed_arr: any;
  failed_arr: any;
  data = {
    status: true,
    data: {
      noofloansbooked: 2,
      sumofloansbooked: 30000,
      totalloansbooked: 1837,
      percent_loans: 0.10887316276538,
      nooftimeslate: 0,
      totallate: 0,
      percent_lateness: 30,
      nooftimesearly: 2,
      totalearly: 728,
      percent_early: 0.27472527472527,
      highestprincipal: 20000,
      highesttenor: 30,
      highestinterest: 20,
      loan_performance: []
    },
    analytics: {
      score: 0,
      internal_repayments: {
        borrowing_status: {
          not_a_first_time_borrower: 'true',
          borrowed_once: 'true',
          borrowed_twice: 'false',
          borrowed_five: 'false',
          borrowed_ten: 'false'
        },
        lateness_of_payment: 'false',
        lateness: 'false',
        repaid_early: 'false',
        received_higher_principal: 'false',
        received_lower_principal: 'true',
        received_higher_tenure_days: 'false',
        received_lower_tenure_days: 'true',
        received_higher_interest_rate: 'false',
        received_lower_interest_rate: 'false',
        score: 0
      },
      external_repayments: {
        external_requests_allowed: 'false',
        external_lateness_exists: 'false',
        received_higher_principal: 'false',
        received_higher_tenure_days: 'false',
        received_higher_interest_rate: 'false',
        score: 33.33333333333333
      }
    }
  };
  //view: any = 'data_view';
  sms_value: any;
  guarantor_value: any;
  call_logs_value: any;
  cards_value: any;
  profile_value: any;
  social_value: any;
  accounts_value: any;
  dd_value: any;
  repayment_value: any;
  params: any = JSON.parse(localStorage.getItem('params'));
  repayment_status: any;
  highest_interest: any;
  highest_tenor: any;
  highest_principal: any;
  loans_borrowed: any;
  times_late: any;
  early_repayment: any;
  loans_early: any;
  total_amt_borrowed: any;
  highlights: any;
  analytics_score: number;
  repayment_data: any;
  loading: boolean;
  analytics: any[];
  compared_data: any;
  nodes_and_scores: any;
  analytics_last_done = '';
  analyzed_data: any[];
  customer_name: any;
  constructor(
    public route: ActivatedRoute,
    public storageService: StorageService,
    public optionsService: OptionsserviceService,
    public loansService: LoansService,
    public operationsService: OperationsService,
    public dataService: DataService,
    public analyticsService: AnalyticsService,
    private http: HttpClient,
    public router: Router,
    private _location: Location
  ) {
    this.currentUser = this.storageService.read<any>('currentUser');
  //  this.repayment_value = this.params.repayments;
  }
  ngOnInit() {
    this.getAnalyticsData();
    //this.getAnalytics();
  }
  getAnalyticsData() {
    this.loading = true;
    this.sub = this.route.params.subscribe(params => {
      this.parentRouteId = +params['id'];
      this.loansService
        .getRepaymentAnalyticsData(this.currentUser.token, this.parentRouteId)
        .subscribe(data => {
          this.loading = false;
          this.loan = data.loan;
          this.customer_name = data.loan.customer.legal_name;
          this.full_analytics = data;
          this.analytics = data.loan.analytics_summary.description.repayments_;
          this.passed_arr = data.loan.analytics_summary.counts.repayments_passed;
          this.failed_arr =  data.loan.analytics_summary.counts.repayments_failed;
          this.repayment_status = data.loan.analytics_summary.status.repayments;
          this.highlights = data.loan.analytics_summary.repayment_performance;
          this.analytics_score = data.loan.analytics_summary.final_analytics_score * 100;
          this.repayment_data = data.loan.analytics_summary.repayment_data;
          this.data.data.loan_performance = data.loan.analytics_summary.loan_performance;
          this.analyzed_data = this.analytics.filter(analysis => {
            return analysis.status === 'failed';
          });
          this.dataService.onRequestLoadingEndFromBackend.emit({loan:data.loan});
          // this.highest_interest = this.details.data.highestinterest;
          // this.highest_tenor = this.details.data.highesttenor;
          // this.highest_principal = this.details.data.highestprincipal;
          // this.loans_borrowed = this.details.data.noofloansbooked;
          // this.times_late = this.details.data.nooftimeslate;
          // this.loans_early = this.details.data.nooftimesearly;
          // this.total_amt_borrowed = this.details.data.sumofloansbooked;
          // this.early_repayment = this.details.data.totalearly;

        });
    });
  }
  modifyAnalytics(event) {
    this.dataService.onEditApplicationsModal.emit({
      section: 'specific_analytics',
      request_id: this.parentRouteId,
      nodes_and_scores: this.nodes_and_scores,
      selected_analytics: '1',
      analytics_last_done: this.analytics_last_done,
      isedit: '1'
    });
  }
  dataView() {
    this.view = 'data_view';
  }

  analyticsView() {
    this.view = 'analytics_view';
  }
  openModal(section) {
    this.dataService.onOpenApplicationsModal.emit({
      section: section,
      request_id: this.parentRouteId
    });
  }
  opencrawler(event) {
    this.router.navigate([
      'applications/analytics/' + this.parentRouteId + '/spider'
    ]);
  }
  doingDisbursement(event) {
    event.new_loan = this.loan;
    this.dataService.disbursingRequest.emit(event);
  }
  openOfferLetter(request_id) {
    this.router.navigate(['./applications/offerletter/' + request_id]);
  }
  getAnalytics() {
    return new Promise((resolve, reject) => {
      return this.http
        .post<any>(`https://eligibilitytest.creditclan.com/public/requestparams`, {
          request_id: '13126'
        })
        .toPromise()
        .then(res => {
          //console.log(res);
          this.lender_id = res.lender_id;
          this.borrower_id = res.borrower_id;
          this.principal = res.principal;
          this.maturity_date = res.maturity_date;
          this.account_card_id = res.account_card_id;
          this.loan_request_id = res.loan_request_id;
          this.card_id = res.card_id;
          resolve();
        })
        .then(res => {
          //console.log(res);
          this.getFullAnalytics();
        })
        .catch(err => {
          //console.log(err);
          reject();
        });
    });
  }
  getFullAnalytics() {
     
  }
  goBack() {
    this._location.back()
  }
}
